import { connect } from "react-redux";
import { get } from "lodash";
import PageLayout from "../components/pageLayout/PageLayout";
import UserConfig from "../../shared/actions/configActions";
import { getOnly3D } from "../../shared/selectors/unit/unit";
import { getI18N, getUser } from "../../shared/selectors";

// Which part of the Redux global state does our component want to receive as props?
const mapStateToProps = (state, props) => {
  const projectId = get(props, "params.projectId");
  const unitId = get(props, "params.id");
  // This was used to display a logo above the actual banner image.
  // In order to provide a fallback for older accounts, this is still left in.
  const legacyLogoPath = projectId
    ? get(state, `branding.${projectId}.banner_url`, "")
    : get(state, "branding.account.logo.banner", "");

  const projectBranding = get(state.branding, projectId);

  const accountLogoUrl = get(
    state.branding.account,
    "logo.half_banner",
    legacyLogoPath
  );

  const projectLogoUrl = get(state, `branding.${projectId}.logo_url`, "");
  const projectBannerImageUrl = get(
    state,
    `branding.${projectId}.banner_image_url`,
    ""
  );

  const unitPath = `/${projectId}/musterwohnung/${unitId}`;

  const layoutScope = props.routes.reduce((accu, r) => {
    return r.layoutScope;
  });

  return {
    i18n: getI18N(state),
    accountLogoUrl,
    projectBranding,
    projectLogoUrl,
    projectBannerImageUrl,
    unitPath,
    unitId,
    pageName: props.route.name,
    message: state.message,
    user: getUser(state, props),
    projectId,
    projectStyles: get(state, `branding.${projectId}.styles`, ""),
    accountStyles: get(state, "branding.account.styles", ""),
    userConfig: new UserConfig(),
    layoutScope,
    only3D: getOnly3D(props)
  };
};

export default connect(mapStateToProps)(PageLayout);
